export interface StandardCatalogState { search: string; sort: string; page: number; scroll: number; }

const STATE_PREFIX = 'standardCatalog:';
const DEFAULT_SORT = 'number,asc';
const FIRST_PAGE = 1;
const TOP = 0;
const VALID_SORT = /^(number|ruName|enName|standardType\.ruName|standardType\.enName),(asc|desc)$/;
const EMPTY_SEARCH = '';
const STRING_TYPE = 'string';
const BROWSER_WINDOW = window;
const BROWSER_DOCUMENT = document;
const ANCHOR_TAG = 'a';
const PDF_MIME = 'application/pdf';
const NEW_WINDOW = '_blank';

export function readCatalogState(userId: string): StandardCatalogState {
  const fallback = {search: EMPTY_SEARCH, sort: DEFAULT_SORT, page: FIRST_PAGE, scroll: TOP};
  try {
    const state: StandardCatalogState = JSON.parse(sessionStorage.getItem(STATE_PREFIX + userId));
    if (!state || typeof state.search !== STRING_TYPE || !VALID_SORT.test(state.sort)) { return fallback; }
    if (!Number.isSafeInteger(state.page) || state.page < FIRST_PAGE || !Number.isFinite(state.scroll)) { return fallback; }
    return {search: state.search, sort: state.sort, page: state.page, scroll: Math.max(TOP, state.scroll)};
  } catch (error) { return fallback; }
}

export function saveCatalogState(userId: string, state: StandardCatalogState): void {
  try { sessionStorage.setItem(STATE_PREFIX + userId, JSON.stringify(state)); } catch (error) { return; }
}

export function catalogScroll(): number { return BROWSER_WINDOW.pageYOffset || TOP; }
export function restoreCatalogScroll(scroll: number): void { BROWSER_WINDOW.scrollTo(TOP, scroll); }

export function downloadCatalogFile(blob: Blob, name: string): void {
  const link = BROWSER_DOCUMENT.createElement(ANCHOR_TAG);
  const url = BROWSER_WINDOW.URL.createObjectURL(blob);
  link.href = url;
  link.download = name;
  link.click();
  link.remove();
  BROWSER_WINDOW.URL.revokeObjectURL(url);
}

export function openCatalogPdf(blob: Blob): void {
  const url = BROWSER_WINDOW.URL.createObjectURL(new Blob([blob], {type: PDF_MIME}));
  BROWSER_WINDOW.open(url, NEW_WINDOW);
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/my-standards/standard-catalog-state.ts